import React, { FC } from "react";
import { useWebTranslation } from "translations";
import { Checkbox } from "ui-kit/Checkbox";
import { FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";

type PreviousInjuriesListItemProps = {
  onPress: () => void;
  active: boolean;
  name: string;
  title: string;
  text: string;
  id: string;
  disabled: boolean;
};

export const PreviousInjuriesListItem: FC<PreviousInjuriesListItemProps> = ({
  name,
  title,
  text,
  active,
  onPress,
  disabled,
}) => {
  const { t } = useWebTranslation();

  return (
    <div onClick={() => !disabled && onPress()} style={{ cursor: "pointer" }}>
      <FlexRow
        style={{ gap: 8 }}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
      >
        <div>
          <Typography component={"div"}>{t(title, { name })}</Typography>
          <Typography>{t(text, { name })}</Typography>
        </div>
        <Checkbox active={active} />
      </FlexRow>
    </div>
  );
};
